module.exports = __webpack_public_path__ + "img/juicelamp.ae2f41f0.png";